import React from 'react';
import MainPage from "./pages/MainPage/MainPage";
import './App.css';

function App() {
  return (
    <div>
      <MainPage></MainPage>
    </div>
  );
}

export default App;
